import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {createBrowserHistory} from 'history';
import {Amplify} from 'aws-amplify';
import awsconfig from './amplifyconfiguration.json';
import {
  InitEnvironmentVariable,
  InitWithAmplify,
  InitWithPikadoClient,
} from '@PikaDoApp/npm-pikado-logic';
import {getEnvironment} from './lib/getEnvironment';
import {store} from './redux/store';
import {clearAuthState, clearAuthStorage} from './redux/actions/user';

import 'video-react/dist/video-react.css'; // import css
export const browserHistory = createBrowserHistory();
Amplify.configure(awsconfig);
InitWithAmplify(Amplify);
InitEnvironmentVariable(getEnvironment());

const expireSession = () => {
  clearAuthStorage();
  store.dispatch(clearAuthState() as any);
};

InitWithPikadoClient({
  environment: getEnvironment,
  getAccessToken: () => localStorage.getItem('pikado_auth_token'),
  getRefreshToken: () => localStorage.getItem('pikado_refresh_token'),
  refreshAccessToken: async refreshToken => {
    const {UserService} = await import('@PikaDoApp/npm-pikado-logic');
    try {
      const response = await new UserService().refreshToken({refreshToken});

      if (!response?.token || !response?.refreshToken) {
        expireSession();
        return null;
      }

      localStorage.setItem('pikado_auth_token', response.token);
      localStorage.setItem('pikado_refresh_token', response.refreshToken);

      return response;
    } catch (error) {
      expireSession();
      return null;
    }
  },
  onUnauthorized: () => {
    expireSession();
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
